export default __webpack_public_path__ + "static/media/img_faruque.0b2c04ef.png";